module.exports = __webpack_public_path__ + "static/media/icon_chat_error.0352a9c7.svg";